import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getplanByName = createAsyncThunk(
    "plans/getplanbyname",
    async ({ token,name }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/plans/${name}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.data.status) {
                return response.data.response
            } else {
                return rejectWithValue("Failed to fetch plans");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const createplan = createAsyncThunk(
    "plans/createplan",
    async ({ token, formData, }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/plans`,
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to create plan");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const editeplan = createAsyncThunk(
    "plans/editeplan",
    async ({ token, formData, id }, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/plans/${id}`,
                formData,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to edit plan");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getplans = createAsyncThunk(
    "plans/getplans",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/plans/list`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            if (response.data.status) {
                return response.data.response;
            } else {
                return rejectWithValue("Failed to fetch plans");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const initialState = {
    plans: [],
    isLoading: false,
    error: null,
};

const plansSlice = createSlice({
    name: "plans",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getplans.fulfilled, (state, action) => {

                state.plans = action.payload;
            })
            .addCase(createplan.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(createplan.fulfilled, (state, action) => {
                state.isLoading = false

                // state.plans.unshift(action.payload);
            })
            .addCase(createplan.rejected, (state, action) => {
                state.isLoading = false

                toast("Error")
            })
            .addCase(editeplan.pending, (state, action) => {
                state.isLoading = true
            })
            .addCase(editeplan.fulfilled, (state, action) => {
                state.isLoading = true
                // const index = state.plans.findIndex(plan => plan._id === action.payload._id);
                // if (index !== -1) {
                //     state.plans[index] = action.payload;
                // }
                toast("Edit the plan Succesfully ")
            })
            .addCase(editeplan.rejected, (state, action) => {
                state.isLoading = false
                toast("Error")
            })
            .addCase(getplans.pending, (state) => {
                state.isLoading = true
                state.error = null;
            })
            .addCase(getplans.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload || "Something went wrong";
            });
    },
});

export default plansSlice.reducer;
